/* ==================================================================
   NOSH MYSTERY BOX EXPERIENCE                        [2026-10-05]
   ==================================================================
   Loaded ONLY by sections/nosh-mystery-box-experience.liquid (the
   dedicated Mystery Box collection template). It does three small jobs
   and owns no video or cart logic of its own:

     1. Remembers a dismissed teaser for the session (sessionStorage,
        wrapped: it can be blocked).
     2. Steps the floating teaser aside while any higher-priority overlay
        is open: the 10% popup, the cart drawer (which includes Almost
        there), the filter or menu drawers, or the viewer itself. It
        returns when they close, unless the customer dismissed it.
     3. Closes the viewer after a REAL add to cart from inside it, then opens
        the cart drawer. A showModal() dialog sits above the cart drawer, so
        it must close first. assets/nosh-cart.js deliberately suppresses
        Dawn's automatic drawer open and shows an "Added to cart" toast, so
        the drawer is opened here explicitly (via the element's prototype,
        which that patch leaves alone) and the now-redundant toast is
        dismissed. Set OPEN_DRAWER_AFTER_ADD to false to keep the toast only.

   The viewer itself is assets/nosh-video.js; the add to cart is Dawn's
   <product-form>. No second video system, no second cart system.
   ================================================================== */
(function () {
  'use strict';

  var VERSION = 1;
  if (window.NoshMbx && window.NoshMbx.version === VERSION) {
    window.NoshMbx.refresh();
    return;
  }

  var DISMISS_KEY = 'noshMbxMiniDismissed';
  var OPEN_DRAWER_AFTER_ADD = true;
  var observers = [];
  var scheduled = false;

  function mini() {
    return document.querySelector('[data-nosh-mbx-mini]');
  }

  /* ---- 1. dismissal ----------------------------------------------- */
  function isDismissed() {
    try {
      return window.sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function dismiss() {
    var m = mini();
    if (m) m.classList.add('is-dismissed');
    try {
      window.sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (e) {
      /* storage blocked: it simply returns on the next page */
    }
  }

  /* ---- 2. overlay collision --------------------------------------- */
  function overlayActive() {
    var popup = document.getElementById('NoshOfferPopup');
    if (popup && (!popup.hidden || popup.classList.contains('is-open'))) return true;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) return true;
    if (document.documentElement.classList.contains('nosh-vlb-open')) return true;
    if (document.body && document.body.classList.contains('overflow-hidden')) return true;
    return false;
  }

  function sync() {
    scheduled = false;
    var m = mini();
    if (m) m.classList.toggle('is-suspended', overlayActive());
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    /* A timer, not requestAnimationFrame: rAF never fires in a background
       tab, which would leave the teaser in the wrong state on return. */
    window.setTimeout(sync, 16);
  }

  function watch(target, filter) {
    if (!target || !window.MutationObserver) return;
    var o = new MutationObserver(schedule);
    o.observe(target, { attributes: true, attributeFilter: filter });
    observers.push(o);
  }

  function unwatchAll() {
    while (observers.length) observers.pop().disconnect();
  }

  /* ---- 3. close the viewer after a real add to cart ---------------- */
  function openDrawerAfterAdd() {
    window.setTimeout(function () {
      var drawer = document.querySelector('cart-drawer');
      var Ctor = window.customElements && window.customElements.get('cart-drawer');
      if (!drawer || !Ctor || typeof Ctor.prototype.open !== 'function') return;
      /* The prototype method, not drawer.open: assets/nosh-cart.js briefly
         swaps the instance method for a no-op while an add renders. */
      Ctor.prototype.open.call(drawer);
      if (window.NoshCart && typeof window.NoshCart.hideToast === 'function') window.NoshCart.hideToast();
    }, 60);
  }

  if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      if (!document.querySelector('dialog.nosh-vlb--shop[open]')) return;
      if (window.NoshVideo && typeof window.NoshVideo.close === 'function') {
        window.NoshVideo.close({ restoreFocus: false });
      }
      if (OPEN_DRAWER_AFTER_ADD) openDrawerAfterAdd();
      schedule();
    });
  }

  /* ---- boot --------------------------------------------------------- */
  function refresh() {
    var m = mini();
    if (m && !m.getAttribute('data-nosh-mbx-bound')) {
      m.setAttribute('data-nosh-mbx-bound', '1');
      var x = m.querySelector('[data-nosh-mbx-dismiss]');
      if (x) x.addEventListener('click', dismiss);
      if (isDismissed()) m.classList.add('is-dismissed');
    }
    unwatchAll();
    watch(document.documentElement, ['class']);
    watch(document.body, ['class']);
    watch(document.querySelector('cart-drawer'), ['class']);
    watch(document.getElementById('NoshOfferPopup'), ['hidden', 'class']);
    sync();
  }

  document.addEventListener('shopify:section:load', refresh);

  window.NoshMbx = { version: VERSION, refresh: refresh, overlayActive: overlayActive };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
